import type { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { buildTranscribeRequest, DictationProvider } from '@dooglie/ui';
import API from '../API';
import type { RootState } from '../store';

/** The backend's prerelease key for the mic in every text field. */
export const VOICE_INPUT = 'voice_input';

/** One clip to `/transcribe_voice`; the answer is its words. */
export async function transcribeVoice(blob: Blob, field: string, hint?: string): Promise<string> {
  const { data } = await API.post('/transcribe_voice', await buildTranscribeRequest(blob, field, hint));
  return String((data as { text?: unknown } | undefined)?.text ?? '');
}

/**
 * Dictation for every `TextInput` in the web app. As `PrereleaseRoute`: off
 * until `/get_user_info` answers, and off for a viewer `voice_input` is
 * hidden from (on prod, anyone but Dooglie staff), so no mic is drawn.
 */
export function VoiceDictation({ children }: { children: ReactNode }) {
  const hidden = useSelector((s: RootState) => s.user.hidden_features);
  const enabled = hidden !== undefined && !hidden.includes(VOICE_INPUT);
  return (
    <DictationProvider enabled={enabled} transcribe={transcribeVoice}>
      {children}
    </DictationProvider>
  );
}
